import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getStorageQuota } from '@/lib/storage-utils';
import { useBanner } from '@/hooks/useBanner';
import { useCurrentPerson } from '@/hooks/useCurrentPerson';
import { isAuthRoute, LOW_STORAGE_MESSAGE } from './messages';

const LOW_STORAGE_THRESHOLD = 5 * 1024 * 1024; // 5 MB

/** Posts the low-storage warning while less than 5 MB is left for the app. */
export function useLowStorageBanner(): void {
  const { pathname } = useLocation();
  const { organizationId } = useCurrentPerson();
  const active = organizationId !== null && !isAuthRoute(pathname);
  const [low, setLow] = useState(false);

  useEffect(() => {
    const check = async () => {
      const quota = await getStorageQuota();
      if (!quota) return;
      setLow(quota.quota - quota.usage < LOW_STORAGE_THRESHOLD);
    };
    void check();
    const interval = setInterval(check, 2 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  useBanner(active && low ? LOW_STORAGE_MESSAGE : null);
}
